module.exports = __webpack_public_path__ + "img/directions_car.553cc134.svg";